import $ from 'jquery';
import validate from 'jquery-validation';
import select2 from 'select2';

$(() => {
	$(document).ready(function () {
		/* Мобильное меню */
		$(function () {
			const btnShow = $('.mobile-header__menu');
			const menu = $('.mobile-menu');
			const btnClose = $('.mobile-menu__close');

			btnShow.on('click', function () {
				menu.fadeIn();
			});

			btnClose.on('click', function () {
				menu.fadeOut();
			});
		});

		/* Табы для групп */
		$(function () {
			const wrapper = $('.group');
			const allTabs = wrapper.find('.group-tab');
			const menu = wrapper.find('.group-menu__item');

			allTabs.not(':first-of-type').hide();

			menu.each(function (i) {
				$(this).attr('data-tab', 'tab' + i);
			});

			allTabs.each(function (i) {
				$(this).attr('data-tab', 'tab' + i);
			});

			menu.on('click', function () {
				var dataTab = $(this).data('tab');
				console.log(dataTab);
				const thisWrapper = $(this).closest(wrapper);

				thisWrapper.find(menu).removeClass('group-menu__item_active');
				$(this).addClass('group-menu__item_active');

				thisWrapper.find(allTabs).hide();
				thisWrapper.find(allTabs).filter('[data-tab=' + dataTab + ']').show();
			});
		});

		/* Табы для галереи */
		$(function () {
			const wrapper = $('.gallery');
			const allTabs = wrapper.find('.gallery-list');
			const menu = wrapper.find('.gallery-menu__item');

			allTabs.not(':first-of-type').hide();

			menu.each(function (i) {
				$(this).attr('data-tab', 'tab' + i);
			});

			allTabs.each(function (i) {
				$(this).attr('data-tab', 'tab' + i);
			});

			menu.on('click', function () {
				var dataTab = $(this).data('tab');
				console.log(dataTab);
				const thisWrapper = $(this).closest(wrapper);

				thisWrapper.find(menu).removeClass('gallery-menu__item_active');
				$(this).addClass('gallery-menu__item_active');

				thisWrapper.find(allTabs).hide();
				thisWrapper.find(allTabs).filter('[data-tab=' + dataTab + ']').show();
			});
		});

		/* F.A.Q. */
		$(function () {
			$('.faq-list__answer').not('.faq-list__item:first-of-type .faq-list__answer').hide();
			$('.faq-list__question').click( function () {
				const answer = $(this).next();
				const faq = $(this).closest('.faq-list');
				const question = faq.find('.faq-list__question');

				if (answer.is(':visible'))
				{
					$(this).removeClass('faq-list__question_active');
					answer.slideUp();
				}
				else
				{
					faq.find('.faq-list__answer').slideUp();
					faq.find(question).removeClass('faq-list__question_active');
					$(this).addClass('faq-list__question_active');
					answer.slideDown();
				}
			});
		});

		/* Validation Contact Form */
		$(function () {
			$('#contacts-form').validate({
				rules: {
					name: 'required',
					email: {
						required: true,
						email: true
					},
					question: 'required',
					confirm: 'required'
				},
				messages: {
					name: 'Пожалуйста представтесь.',
					email: {
						required: 'Введите ваш email.',
						email: 'Не верно введен email.'
					},
					question: 'Введите ваш вопрос.',
					confirm: 'Согласие на обработку персональных данных, является обязательным.'
				}
			});
		});

		/* Validation Registration Form */
		$(function () {
			$('#registration').validate({
				rules: {
					'program[]': {
						required: true,
						minlength: 1
					},
					parents: 'required',
					kids: 'required',
					dobNumber: 'required',
					dobMount: 'required',
					dobYear: 'required',
					phone: 'required',
					email: {
						required: true,
						email: true
					},
					confirm: 'required'
				},
				errorPlacement: function (error, element) {
					console.log(element.prop('tagName'));
					if (element.attr('type') === 'checkbox' && element.attr('name') !== 'confirm') {
						error.insertAfter($(element).parents('.checkbox-program').parents('.form__column').parents('.form__two-columns').prev($('.error__program')));
					}else if (element.prop('tagName') === 'SELECT') {
						$(element).siblings('.select__error').append(error);
					}else {
						error.insertAfter($(element));
					}
				},
				messages: {
					'program[]': 'Выберите программу обучения.',
					parents: 'Введите Имя и Фамилию родителя',
					kids: 'Введите Имя и Фамилию ребёнка',
					dobNumber: 'Выберите дату рождения',
					dobMount: 'Выберите месяц рождения',
					dobYear: 'Выберите год рождения',
					phone: 'Введите телефон',
					email: {
						required: 'Введите ваш email.',
						email: 'Не верно введен email.'
					},
					confirm: 'Согласие на обработку персональных данных, является обязательным.'
				}
			});
		});

		/* Validation Program Form */
		$(function () {
			$('#program-form').validate({
				rules: {
					parents: 'required',
					kids: 'required',
					dobNumber: 'required',
					dobMount: 'required',
					dobYear: 'required',
					phone: 'required',
					email: {
						required: true,
						email: true
					},
					confirm: 'required'
				},
				errorPlacement: function (error, element) {
					console.log(element.prop('tagName'));
					if (element.prop('tagName') === 'SELECT') {
						$(element).siblings('.select__error').append(error);
					}else {
						error.insertAfter($(element));
					}
				},
				messages: {
					parents: 'Введите Имя и Фамилию родителя',
					kids: 'Введите Имя и Фамилию ребёнка',
					dobNumber: 'Выберите дату рождения',
					dobMount: 'Выберите месяц рождения',
					dobYear: 'Выберите год рождения',
					phone: 'Введите телефон',
					email: {
						required: 'Введите ваш email.',
						email: 'Не верно введен email.'
					},
					confirm: 'Согласие на обработку персональных данных, является обязательным.'
				},
				submitHandler: function (form) {
					$.ajax({
						url: '/assets/php/program.php',
						type: 'POST',
						data: new FormData($(form)),
						cache: false,
						processData: false,
						success: function (data) {
							$('#program-form').hide();
							// $("#message").html(data);
						}
					});
				}
			});
		});

		/* Select single*/
		$('.js-example-basic-single').select2({
			minimumResultsForSearch: Infinity
		});

		/* Select multiple*/
		$('.js-example-basic-multiple').select2({
			placeholder: 'Дополнительная программа обучения'
		});
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js